export default __webpack_public_path__ + "static/media/night_empty.7cbd1677.svg";